/**
 * 默认的图片消息组件
 */
import React from 'react'
import { DeleteIcon } from '../../../conf/images'
import { ImageMessageContent } from '../interface'

interface TextMessageDefaultProps extends ImageMessageContent {
    onDelete: () => void
}

const ImageMessageDefault: React.FC<TextMessageDefaultProps> = (props) => {
    return (
        <div className='imageMessageBox'>
            <img
                src={props.img_url}
                className='imageMessageBoxImage'
                alt='userImage'
            />
            <img
                onClick={props.onDelete}
                src={DeleteIcon}
                alt='deleteIcon'
                className='messageDeleteIcon'
            />
        </div>
    )
}

export default ImageMessageDefault
